// Globals
import { useTranslation } from 'react-i18next';

// Components
import { FormItem } from '@/components';
import { CheckmarkIcon } from '@/icons';
import { Input, Select } from '@/ui';
import { FormColumn, StyledButton, StyledWrapper } from '../Styled';
import { StyledForm } from './RedirectFormStyles';

// Modules
import { Resource, usePermissions } from '@/modules/Permissions';

// Models
import { IRedirect } from '@/models/redirects.model';

// Helpers
import { getRedirectTypeOptions } from '../../helpers/getOptions';
import { RedirectsFormFieldsNames } from '../../helpers/types';
import { useRedirectFormRules } from '../../hooks';

interface IRedirectForm {
  handleSubmit: (values: IRedirect) => void;
  isLoading: boolean;
  initialValues?: IRedirect | null;
}

const RedirectForm = ({ handleSubmit, isLoading, initialValues }: IRedirectForm) => {
  const { t } = useTranslation(['redirects', 'common']);
  const { canManage } = usePermissions();
  const rules = useRedirectFormRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  return (
    <StyledWrapper>
      <StyledForm onFinish={handleSubmit} initialValues={initialValues ?? {}}>
        <FormColumn>
          <FormItem
            name={RedirectsFormFieldsNames.TYPE}
            label={t('redirect_status_code')}
            rules={rules[RedirectsFormFieldsNames.TYPE]}
          >
            <Select placeholder={placeholder} options={getRedirectTypeOptions()} size="middle" />
          </FormItem>
          <FormItem
            name={RedirectsFormFieldsNames.SOURCE}
            label={t('redirect_from')}
            rules={rules[RedirectsFormFieldsNames.SOURCE]}
          >
            <Input placeholder={placeholder} size="large" />
          </FormItem>
          <FormItem
            name={RedirectsFormFieldsNames.TARGET}
            label={t('redirect_to')}
            rules={rules[RedirectsFormFieldsNames.TARGET]}
          >
            <Input placeholder={placeholder} size="large" />
          </FormItem>
        </FormColumn>
        {canManage(Resource.SEO) && (
          <StyledButton htmlType="submit" loading={isLoading}>
            <CheckmarkIcon /> {t('redirect_save')}
          </StyledButton>
        )}
      </StyledForm>
    </StyledWrapper>
  );
};

export default RedirectForm;
